
/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  homes.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/7/4 14:44
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { axiosAPIUrl, Parameter } from "./index";

/**
* 签署服务人脸识别
* @param params
*/
export function brushFaceByGuarantee(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjmerchantsborrower/GM/brushFaceByGuarantee',
    method: 'post',
    data: Parameter
  })
}

/**
* 查询签署担保函列表
* @param params
*/
export function getGuaranteeList(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjAuthentication/PersonalAttestation/getIDCard',
    method: 'get',
    params: Parameter
  })
}
/**
* 查询担保确认函
* @param params
*/
export function getSignGuarantee(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjmerchantsborrower/GM/getSignGuarantee',
    method: 'get',
    params: Parameter
  })
}

/**
* 文件下载
* @param parameter
*/
export function downloadFile(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjcommodity/goodsGM/downloadFile",
    method: "get",
    params: parameter,
    responseType: "arraybuffer",
  });
}
/**
* 获取刷脸结果
* @param params
*/
export function getGuaranteeBrushFace(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjmerchantsborrower/GM/getGuaranteeBrushFace',
    method: 'get',
    params: Parameter,
    extraParams:{ showLoading: false }
  })
}
/**
* 签署担保函
* @param params
*/
export function signGuarantee(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjmerchantsborrower/GM/signGuarantee',
    method: 'post',
    data: Parameter
  })
}

/**
* 获取核心企业免息权益说明
* @param params
*/
export function getRegulations(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjmerchantsborrower/companyConfigInformationManagement/getRegulations',
    method: 'get',
    params: Parameter
  })
}

/**
* 获取核心企业免息权益
* @param params
*/
export function getInterestFree(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjmerchantsborrower/companyConfigInformationManagement/getInterestFree',
    method: 'get',
    params: Parameter
  })
}

/**
* 获取核心企业自动化
* @param params
*/
export function getRobotization(Parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjmerchantsborrower/companyConfigInformationManagement/getRobotization',
    method: 'get',
    params: Parameter
  })
}